var ErrorType;
(function (ErrorType) {
    ErrorType["CLIENT"] = "client";
    ErrorType["REQUEST"] = "request";
    ErrorType["RESPONSE"] = "response";
    ErrorType["GENERIC"] = "generic";
    ErrorType["CANCEL"] = "cancel";
})(ErrorType || (ErrorType = {}));
class SdkError extends Error {
    static isSdkError(error) {
        return error && [SdkError.NAME, ApiError.NAME].includes(error.name) && Object.values(ErrorType).includes(error.type);
    }
    constructor(error) {
        super(error.message);
        this.name = SdkError.NAME; // this.constructor.name
        this.type = error.type || ErrorType.GENERIC;
    }
}
SdkError.NAME = 'SdkError';
class ApiError extends SdkError {
    static isApiError(error) {
        return SdkError.isSdkError(error) && (error.name === ApiError.NAME) && (error.type === ErrorType.RESPONSE);
    }
    constructor(error) {
        super({ ...error, type: ErrorType.RESPONSE });
        this.errors = [];
        this.name = ApiError.NAME; // this.constructor.name
    }
    first() {
        var _a;
        return (((_a = this.errors) === null || _a === void 0 ? void 0 : _a.length) > 0) ? this.errors[0] : undefined;
    }
}
ApiError.NAME = 'ApiError';
export { SdkError, ApiError, ErrorType };
